import React from 'react'
import { Icon, IconProps } from '@chakra-ui/core'
import icons from './icons'

export const CustomIcon = (props: IconProps) => {
  const { name } = props
  const icon = name ? icons[name] : undefined
  return (
    <Icon viewBox={icon?.viewBox} fill={icon?.fill} {...props}>
      {icon?.path}
    </Icon>
  )
}
